// extracted by mini-css-extract-plugin
export var chevron = "_fk-2";
export var dropdownItems = "_fk-0";
export var item = "_fk-1";